export const actions = {
  get ({ commit }, { url, config }) {
    return new Promise((resolve, reject) => {
      this.$axios.get(url, config)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  post ({ state, commit }, { url, data, config }) {
    return new Promise((resolve, reject) => {
      this.$axios.post(url, data, config)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  put ({ state, commit }, { url, data, config }) {
    return new Promise((resolve, reject) => {
      this.$axios.put(url, data, config)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
